import { FeatureFlag } from '../FeatureFlag';

export const enableUnifiedToasts = new FeatureFlag({
    key: 'enable-unified-toasts',
    createdOn: '2026-07-02',
    defaultValue: false,
});
